/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { css, jsx } from '@emotion/react';
import { Column, Cell, Table, SelectionModes } from "@blueprintjs/table";
import React from 'react'; 
import { MatrixProps } from './interfaces';

/**
 * A matrix 
 * @param data
 * @param widgetConfiguration
  */
export const MatrixWidget: React.FC<MatrixProps> = (({ data, widgetConfiguration }) => {
    const cellRenderer = ((rowIndex: number, columnIndex: number) => {
        return <Cell 
            /*Reference for when color encoding gets implemented: style={{backgroundColor: 'red'}}*/ 
            key={rowIndex + "_" + columnIndex} 
            wrapText={true} 
            interactive={true}
            > 
                {data?.matrix[rowIndex][columnIndex]}
        </Cell> 
    }); 

    return (
        <React.Fragment>
            <Table 
                numRows={Object.keys(data?.matrix).length} 
                selectionModes={SelectionModes.ALL} 
                numFrozenRows={1} 
                numFrozenColumns={2}
                enableRowHeader={false}
                enableMultipleSelection={true}
                >
                { data?.column_headers.map((col_header: string) => 
                    <Column key={col_header} 
                            name={col_header} 
                            cellRenderer={cellRenderer}
                    />)}
            </Table>
        </React.Fragment>
    ); 
});
